"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ReplaceSlides", {
  enumerable: true,
  get: function get() {
    return _ReplaceSlides["default"];
  }
});
var _ReplaceSlides = _interopRequireDefault(require("./ReplaceSlides"));